import { EnvironmentCountries } from '@e-origin/shared';
import { getTranslation } from '@e-origin/utb-report-template';

import { useSettings } from '@hooks/useSettings';

export const useTranslation = () => {
  const { data: settings } = useSettings();
  const language = settings.country === EnvironmentCountries.BE ? 'EN' : settings.country;
  const t = (path: string, variables: Record<string, any> = {}): string => getTranslation(path, language, variables);

  return { t };
};
